import Vue from 'vue';
import cookie from './cookie.js';
import {AccountInfo} from './axios.js';
import PageSource from './PageSource.js';

export const getPageSource = () => {
  const from = window.PAGE_FROM;
  const res = (location.href || '').match(/([^\/]+)\.html/i);
  const page = res && res.length ? res[1] : '';
  const routeName = from && from.name || '';
  if (!routeName) return page == 'course' ? 'external_source' : document.referrer;
  let fPage;
  const pageData = PageSource[page];
  return pageData ? pageData[from.name] : document.referrer;
}

const Log = {
  install: function(Vue) {
    Vue.prototype.$log = function(eventName, params) {
      const account = AccountInfo.getAccountFromSys();
      let commonParams = {
        timeStamp: new Date().getTime(),
        customer_id: account.customerId,
        xiaomi_ID: cookie.getItem('userId'),
        cookie: document.cookie,
        include_superview: !!(cookie.getItem('adSaKey') || cookie.getItem('adSvKey'))
      };
      eventName == 'view' && (commonParams.from_page_source = getPageSource());
      onetrack('track', eventName, Object.assign({}, commonParams, params));
    };
  }
};

export default Log;
